import { createSlice } from "@reduxjs/toolkit";

let initialState = {
    state: {},
}
const Mfslice = createSlice({
    name: "MutualFundAddReducer",
    initialState,
    reducers: {
        addMF: (state, action) => {
            const { AMFICode, categoryId, subCategoryId } = action.payload
            state.state[`${AMFICode}_${categoryId}`] = action.payload
            // if (state.state.hasOwnProperty(`${AMFICode}_${categoryId}`)) {
            //     state.state[`${AMFICode}_${categoryId}`] = action.payload
            // } else {
            // }
        },
        removeMF: (state, action) => {
            const { AMFICode, categoryId, subCategoryId } = action.payload
            if (state.state.hasOwnProperty(`${AMFICode}_${categoryId}`)) {
                state.state[`${AMFICode}_${categoryId}`].subCategoryId = [""]
            } else {
                delete state?.state?.[`${AMFICode}_${categoryId}`]
            }
        }

    }
})
export const { addMF } = Mfslice.actions
export default Mfslice;